import { useEffect, useState } from 'react';
import Addresses from './Addresses';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../Components/LoadingSpinner';
import YesNoMessageModal from '../../Components/Modals/YesNoMessageModal';
import { useCustomer } from '../../../Providers/CustomerProvider';
import AddEditDeliveryAddress from './AddEditDeliveryAddress';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';
import { useParams } from '../../../Providers/ParamsProvider.jsx';

const AddressesCard = () => {
    const [showMessage, setShowMessage] = useState(false)
    const [message, setMessage] = useState('')
    const [title, setTitle] = useState('')
    const [mode, setMode] = useState(0)
    const { addressesWithoutMain, isLoadingAddressesWithoutMain, deleteDeliveryAddress, handleGetDeliveryAddresses, setDeliveryAddressAsMain } = useCustomer()
    const [recNo, setRecNo] = useState(0)
    const [handlingAddress, setHandlingAddress] = useState({ name: '', street: '', zipCode: '', city: '', email: '', phone: '', recNo: 0, isExpAddress: false, expirationDate: '' })
    const handleDelete = (address) => {
        setMessage('Czy na pewno chcesz usunąć adres?')
        setTitle('Usuwanie adresu')
        setRecNo(address.recNo)
        setMode(1)
        setShowMessage(true)
    }
    const { t } = useTranslation()
    const [isChangeAddressVisible, setisChangeAddressVisible] = useState(false);
    const { isUserHasAccess } = useCheckUserRole()
    const { isMobile } = useParams()

    useEffect(() => {
        handleGetDeliveryAddresses(false)
    }, [])

    const handleAddAddressButtonClick = () => {
        setisChangeAddressVisible(true);
    }

    const handleEdit = (address) => {
        setHandlingAddress({ name: address.fullName, street: address.street, zipCode: address.zipCode, city: address.city, email: address.email.trim(), phone: address.phoneNumber, recNo: address.recNo, isExpAddress: address.effectiveDate ? true : false, expirationDate: address.effectiveDate ? address.effectiveDate : '' })
        setisChangeAddressVisible(true);
    }

    const onHide = async (answer) => {
        setShowMessage(false)
        if (answer) {
            if (mode === 1) {
                await deleteDeliveryAddress(recNo)
                handleGetDeliveryAddresses(true)
                handleGetDeliveryAddresses(false)
            } else if (mode === 2) {
                await setDeliveryAddressAsMain(recNo)
                handleGetDeliveryAddresses(true)
                handleGetDeliveryAddresses(false)
            }
            setRecNo(0)
            setMessage('')
            setTitle('')
            setMode(0)
        } else {
            setRecNo(0)
            setMessage('')
            setTitle('')
            setMode(0)
        }
    }

    const handleSetMain = (address) => {
        setMessage('Czy na pewno chcesz ustawić adres jako główny adres dostawy?')
        setTitle('Głowny adresu')
        setRecNo(address.recNo)
        setMode(2)
        setShowMessage(true)
    }

    return (
        <div>
            <div className='row justify-content-center'>
                <div className='col-12 col-xxl-8 mt-2'>
                    <div className='justify-content-center'>
                        <div className='main-container-holder'>
                            <AddEditDeliveryAddress handlingAddress={handlingAddress} setHandlingAddress={setHandlingAddress} isChangeAddressVisible={isChangeAddressVisible} setisChangeAddressVisible={setisChangeAddressVisible} />
                            <div className='panel-header-title'>Wszystkie adresy</div>
                            <div className='table-responsive'>
                                <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: '2%', textAlign: 'center' }}>LP</th>
                                            <th style={{ width: '20%' }}>NAZWA</th>
                                            <th style={{ width: '34%' }}>ADRES</th>
                                            <th style={{ width: '20%' }}>NUMER KONTAKTOWY</th>
                                            <th style={{ width: '18%' }}>TERMIN WAŻNOŚCI</th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                            <th style={{ width: '2%', textAlign: 'center' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isLoadingAddressesWithoutMain && <Addresses addresses={addressesWithoutMain} onDelete={handleDelete} onSetMain={handleSetMain} onEdit={handleEdit} />}
                                    </tbody>
                                </table>
                                {(addressesWithoutMain.length === 0 && addressesWithoutMain && !isLoadingAddressesWithoutMain) && <div style={{ textAlign: 'center' }}>{t("no_data_addresses")}</div>}
                            </div>
                            <YesNoMessageModal show={showMessage} onHide={onHide} title={title} message={message} />
                            {isLoadingAddressesWithoutMain && <LoadingSpinner />}
                            {isUserHasAccess(UserRole.Admin) && <button className='btn-app-secondary mt-3' onClick={handleAddAddressButtonClick}>
                                Dodaj nowy
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default AddressesCard;